<template>
  <b-card no-body class="h-100">
    <b-card-header>
      <b-card-title>Ключевые показатели</b-card-title>
      <b-card-text v-if="weeksCount" class="font-small-2 mr-25 mb-0">
        среднее за {{ weeksCount }} недель
      </b-card-text>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col v-for="card in cards" :key="card.title" cols="6" md="4" class="mb-2">
          <b-media no-body>
            <b-media-aside class="mr-1">
              <b-avatar size="48" :variant="`light-${card.variant}`">
                <feather-icon size="22" :icon="card.icon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0" :class="card.valueClass">{{ card.value }}</h4>
              <b-card-text class="font-small-3 mb-0">{{ card.title }}</b-card-text>
              <small v-if="card.subtitle" class="text-muted">{{ card.subtitle }}</small>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BMediaBody, BAvatar,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatRub, formatPercent, profitVariant } from '@/views/finance/utils'
import { formatNumber } from '@/views/dashboard/sifnf/utils'

export default {
  components: {
    BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BMediaBody, BAvatar,
  },
  props: {
    business: { type: Object, default: null },
    feedback: { type: Object, default: null },
  },
  setup(props) {
    const weeksCount = computed(() => ((props.business && props.business.points) || []).length)

    const gameRatingVariant = value => {
      if (value === null || value === undefined) return 'secondary'
      if (value >= 4.5) return 'success'
      return value >= 4 ? 'warning' : 'danger'
    }

    const cards = computed(() => {
      const kpis = (props.business && props.business.kpis) || {}
      const payouts = (props.business && props.business.payouts_due) || {}
      const averages = (props.feedback && props.feedback.averages) || {}
      const counts = (props.feedback && props.feedback.counts) || {}
      const lastWeek = (props.business && props.business.last_week) || {}
      return [
        {
          title: 'Выручка / неделя', value: formatRub(kpis.avg_weekly_revenue), icon: 'TrendingUpIcon', variant: 'success', valueClass: '',
          subtitle: `Последняя: ${formatRub(lastWeek.revenue)}`,
        },
        {
          title: 'Прибыль / неделя', value: formatRub(kpis.avg_weekly_profit), icon: 'DollarSignIcon',
          variant: profitVariant(kpis.avg_weekly_profit), valueClass: `text-${profitVariant(kpis.avg_weekly_profit)}`,
          subtitle: `Маржа ${formatPercent(kpis.avg_margin)}`,
        },
        {
          title: 'Заполняемость', value: formatPercent(kpis.occupancy), icon: 'UsersIcon', variant: 'warning', valueClass: '',
          subtitle: `ARPU ${formatRub(kpis.arpu)} · частных ${formatPercent(kpis.private_games_share)}`,
        },
        {
          title: 'Долг по выплатам', value: formatRub(payouts.total), icon: 'CreditCardIcon',
          variant: payouts.total > 0 ? 'danger' : 'secondary', valueClass: payouts.total > 0 ? 'text-danger' : '',
          subtitle: `Ведущим ${formatRub(payouts.hosts)} · авторам ${formatRub(payouts.authors)}`,
        },
        {
          title: 'Игр за неделю', value: formatNumber(lastWeek.games_count), icon: 'PlayIcon', variant: 'primary', valueClass: '',
          subtitle: `Игроков: ${formatNumber(lastWeek.players_count)}`,
        },
        {
          title: 'Оценка игры (4 нед.)', value: averages.game != null ? averages.game.toFixed(2) : '—', icon: 'StarIcon',
          variant: gameRatingVariant(averages.game), valueClass: '',
          subtitle: `${formatNumber(counts.reviews)} отзывов`,
        },
      ]
    })

    return { cards, weeksCount }
  },
}
</script>
